import {
  clampFluidManualBrushRadius,
  FLUID_SEGMENTATION_LABELS,
  getActiveFluidLabelsFromApi,
} from "../Views/DCMViewer/utils/fluidManualBrush";
import { clampImageContrast } from "../Views/DCMViewer/utils/imageContrast";

const initState = {
  drawingTools: [
    "Length",
    "Probe",
    "Line",
    "EllipticalRoi",
    "CircleRoi",
    "Brush",
    "RectangleRoi",
    "Text",
    "Angle",
    "RectangleScissors",
    "FreehandRoi",
    "Lison",
    "LisonProbe",
    "MultiLine",
    "MultiPointProbe",
    "AiSegmentation",
    "FluidSegmentation",
  ],
  drawnSegments: {},

  SegmentsToDraw: {},
  dicom_data: {},
  dicom_data_rest_annotation: {},
  currentFrame: 0,
  update: 0,
  width: 80,
  changeId: null,
  changeFrameType: "",
  selectedTool: "MOUSE",
  segmentationEraserMode: "ai",
  selectedKey: null,
  syncScans: false,
  thicknessLUT: {},
  update_data: {},
  stacks: [],
  lineSettings: {
    lineNames: [
      "ILM",
      "RNFL",
      "GCL",
      "IPL",
      "INL",
      "OPL",
      "ONL",
      "ELM",
      "PR",
      "RPE",
      "BM",
    ],
    showHandles: true,
  },
  canSyncScans: false,
  LisonActive: false,
  LisonData: [],
  MlLisonsInputData: [],
  MlLisonsInputsSubmitStatus: false,
  SubmitLisonsStatus: false,
  errorMessage: " ",
  lisonOptions: {
    lisonAreaselected: "modified_spline",
    lisonAreaOptions: [],
    lisonDisplaySelected: "filled",
    lisonDisplayOptions: ["Edges", "filled"],
  },
  lisonsAreasData: {},
  opMetaData: null,
  OpRef: null,
  OpCornerstoneRef: null,
  basicMetaData: {},
  SelectedArea: {
    status: false,
    TotalArea: null,
    LisonsArea: "",
  },
  formDataUserGrading: {
    data: {},
    ready: false,
  },
  mainScreenShotUrl: null,
  displayScreenShotUrl: "",
  local_settings: {
    FluidSegmentation: {
      IRF: true,
      SRF: true,
      PED: true,
      SHRM: true,
    },
  },
  settings: {
    brush: {
      showMasks: false,
      borderRadius: 15,
      /** Diameter in image pixels for fluid segmentation erase tool (circle) */
      fluidEraserDiameter: 20,
      activeSegment: 1,
      showEtdrsMirroring: false,
    },
    screenshot: {
      irBscan: true,
      onlyIr: false,
      onlyBscan: false,
    },
    Segmentation: {
      aiSegmentation: true,
      nativeSegmentation: false,
    },
    FluidSegmentation: {
      IRF: true,
      SRF: true,
      PED: true,
      SHRM: true,
    },
    // Default colors for Fluid Segmentation labels
    FluidSegmentationColors: {
      IRF: "rgba(255, 0, 0, 1)",
      SRF: "rgba(0, 255, 0, 1)",
      PED: "rgba(0, 0, 255, 1)",
      SHRM: "rgba(255, 255, 0, 1)",
    },
    imageContrast: {
      value: 175,
    },
  },

  LoadingOverlay: false,
  fetchedId: null,
  screenShotDisplay: false,
  mlLesionPlayloadData: null,
  mlLesionResponseData: null,
  adjudication_id: "",

  optMetaData: null,
  submitDisable: false,
  dicomRefCombined: null,
  dicomRefBscan: null,
  etdrsActive: false,
  etdrsFallBack: false,
  takeScreenShot: null,
  prevStartRef: null,
  isEtdrsActive: false,
  makeEtdrsActive: true,
  aiSegmentationData: null,
  fluidSegmentation: null,
  activeFluidLabels: [...FLUID_SEGMENTATION_LABELS],
  aiSegmentationAvailable: false,
  edtrsValuesFromSegmentationApi: null,
  etdrsVolumesFromSegmentationApi: null,
  /** IRF | SRF | PED | SHRM | null — required before Brush / Segmentation eraser */
  manualFluidTargetLabel: null,
  /** stroke: paint tube along path; fill: polygon fill on mouse-up */
  fluidBrushDrawingMode: "stroke",
  /** Radius in image pixels for fluid manual brush stroke (Brush / Paint tools) */
  fluidManualBrushRadius: 6,
  /** Frame indices (string keys) with unsaved fluid edits on current stack */
  fluidDirtyFrames: {},
  fluidVolumesSubmitting: false,
  annotationSaveInProgress: false,
  annotationSavePercent: null,
  annotationSaveEtaSeconds: null,
  annotationSaveMessage: "",
  annotationSaveWarningOpen: false,
  /** Last annotation save request that completed successfully (dedupe redundant saves). */
  lastSuccessfulAnnotationSave: null,
  /** Annotation payload for the save request currently in flight. */
  pendingAnnotationSavePayload: null,
  fluidPayloadPointsVisible: false,
};
const dicomReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_FLUID_SEGMENTATION_DATA_FROM_API":
      return {
        ...state,
        fluidSegmentationData: action.fluidSegmentationData,
      };
    case "SET_ETDRS_VOLUMES_FROM_SEGMENTATION_API":
      return {
        ...state,
        etdrsVolumesFromSegmentationApi: action.etdrsVolumesFromSegmentationApi,
      };
    case "SET_ETDRS_VALUES_FROM_SEGMENTATION_API":
      return {
        ...state,
        edtrsValuesFromSegmentationApi: action.edtrsValuesFromSegmentationApi,
      };
    case "opMetaData_changed":
      return {
        ...state,
        opMetaData: action.opMetaData,
      };
    case "SET_AI_SEGMENTATION_AVAILABLE":
      return {
        ...state,
        aiSegmentationAvailable: action.aiSegmentationAvailable,
      };
    case "SET_AI_SEGMENTATION_DATA":
      return {
        ...state,
        aiSegmentationData: action.aiSegmentationData,
      };
    case "SET_FLUID_SEGMENTATION_DATA": {
      const activeFluidLabels = getActiveFluidLabelsFromApi(
        action.fluidSegmentation,
      );
      const manualFluidTargetLabel = activeFluidLabels.includes(
        state.manualFluidTargetLabel,
      )
        ? state.manualFluidTargetLabel
        : null;
      return {
        ...state,
        fluidSegmentation: action.fluidSegmentation,
        activeFluidLabels,
        manualFluidTargetLabel,
      };
    }
    case "SET_ACTIVE_FLUID_LABELS": {
      const activeFluidLabels = action.activeFluidLabels || [];
      const manualFluidTargetLabel = activeFluidLabels.includes(
        state.manualFluidTargetLabel,
      )
        ? state.manualFluidTargetLabel
        : null;
      return {
        ...state,
        activeFluidLabels,
        manualFluidTargetLabel,
      };
    }
    case "MARK_FLUID_FRAME_DIRTY":
      return {
        ...state,
        fluidDirtyFrames: {
          ...state.fluidDirtyFrames,
          [String(action.frameIndex)]: true,
        },
      };
    case "CLEAR_FLUID_FRAME_DIRTY": {
      const nextDirty = { ...state.fluidDirtyFrames };
      delete nextDirty[String(action.frameIndex)];
      return {
        ...state,
        fluidDirtyFrames: nextDirty,
      };
    }
    case "CLEAR_ALL_FLUID_DIRTY_FRAMES":
      return {
        ...state,
        fluidDirtyFrames: {},
      };
    case "SET_FLUID_VOLUMES_SUBMITTING":
      return {
        ...state,
        fluidVolumesSubmitting: Boolean(action.submitting),
      };
    case "SET_ANNOTATION_SAVE_IN_PROGRESS":
      return {
        ...state,
        annotationSaveInProgress: Boolean(action.inProgress),
        ...(action.inProgress
          ? {}
          : {
              annotationSavePercent: null,
              annotationSaveEtaSeconds: null,
              annotationSaveMessage: "",
            }),
      };
    case "SET_ANNOTATION_SAVE_STATUS":
      return {
        ...state,
        annotationSaveInProgress: Boolean(action.active),
        annotationSavePercent:
          action.percent === undefined
            ? state.annotationSavePercent
            : action.percent,
        annotationSaveEtaSeconds:
          action.etaSeconds === undefined
            ? state.annotationSaveEtaSeconds
            : action.etaSeconds,
        annotationSaveMessage:
          action.message === undefined
            ? state.annotationSaveMessage
            : action.message,
      };
    case "SET_ANNOTATION_SAVE_WARNING":
      return {
        ...state,
        annotationSaveWarningOpen: Boolean(action.open),
      };
    case "SET_LAST_SUCCESSFUL_ANNOTATION_SAVE":
      return {
        ...state,
        lastSuccessfulAnnotationSave: {
          cacheKey: action.cacheKey,
          payload: action.payload,
        },
      };
    case "SET_PENDING_ANNOTATION_SAVE_PAYLOAD":
      return {
        ...state,
        pendingAnnotationSavePayload:
          action.cacheKey == null
            ? null
            : {
                cacheKey: action.cacheKey,
                payload: action.payload,
              },
      };
    case "SET_FLUID_PAYLOAD_POINTS_VISIBLE":
      return {
        ...state,
        fluidPayloadPointsVisible: Boolean(action.visible),
      };
    case "SET_SEGMENTS_TO_DRAW":
      return {
        ...state,
        SegmentsToDraw: action.SegmentsToDraw,
      };
    case "SET_DRAWN_SEGMENTS":
      return {
        ...state,
        drawnSegments: action.drawnSegments,
      };
    case "SET_NATIVE_SEGMENTATION":
      return {
        ...state,
        settings: {
          ...state.settings,
          Segmentation: {
            ...state.settings.Segmentation,
            nativeSegmentation: action.nativeSegmentation,
          },
        },
      };
    case "SET_AI_SEGMENTATION":
      return {
        ...state,
        settings: {
          ...state.settings,
          Segmentation: {
            ...state.settings.Segmentation,
            aiSegmentation: action.aiSegmentation,
          },
        },
      };

    case "SET_FLUID_SEGMENTATION_VISIBILITY_GLOBAL":
      return {
        ...state,
        settings: {
          ...state.settings,
          FluidSegmentation: {
            ...state.settings.FluidSegmentation,
            [action.label]: action.value,
          },
        },
        local_settings: {
          ...state.settings,
          FluidSegmentation: {
            ...state.local_settings.FluidSegmentation,
            [action.label]: action.value,
          },
        },
      };
    case "SET_FLUID_SEGMENTATION_VISIBILITY_LOCAL":
      return {
        ...state,
        local_settings: {
          ...state.settings,
          FluidSegmentation: {
            ...state.local_settings.FluidSegmentation,
            [action.label]: action.value,
          },
        },
      };

    case "SET_FLUID_SEGMENTATION_COLOR":
      return {
        ...state,
        settings: {
          ...state.settings,
          FluidSegmentationColors: {
            ...state.settings.FluidSegmentationColors,
            [action.label]: action.color,
          },
        },
      };

    case "makeEtdrsActive_changed":
      return {
        ...state,
        makeEtdrsActive: action.makeEtdrsActive,
      };
    case "takeScreenShot_changed":
      return {
        ...state,
        takeScreenShot: action.takeScreenShot,
      };
    case "isEtdrsActive_changed":
      return {
        ...state,
        isEtdrsActive: action.isEtdrsActive,
      };
    case "etdrsFallBack_changed":
      return {
        ...state,
        etdrsFallBack: action.etdrsFallBack,
      };

    case "etdrs_changed":
      return {
        ...state,
        etdrsActive: action.etdrsActive,
      };
    case "IR_Bscan_combined_dicomRef_changed":
      return {
        ...state,
        dicomRefCombined: action.dicomRef,
      };

    // case "dicomRefIRscan_changed":
    //   return {
    //     ...state,
    //     dicomRefIRscan: action.dicomRef,
    //   };

    case "dicomRefBscan_changed":
      return {
        ...state,
        dicomRefBscan: action.dicomRef,
      };
    case "submitDisabled_changed":
      return {
        ...state,
        submitDisable: action.submitDisable,
      };

    case "optMetaData_changed":
      return {
        ...state,
        optMetaData: action.optMetaData,
      };

    case "Adjudication_id_changed":
      return {
        ...state,
        adjudication_id: action.adjudication_id,
      };

    case "mlLesion_Data_changed":
      return {
        ...state,
        mlLesionPlayloadData: action.mlLesionPlayloadData,
        mlLesionResponseData: action.mlLesionResponseData,
      };

    case "screenShot_Display_changed":
      return {
        ...state,
        screenShotDisplay: action.screenShotDisplay,
      };

    case "displayScreenShot_url_changed":
      return {
        ...state,
        displayScreenShotUrl: action.displayScreenShotUrl,
      };
    case "mainScreenShot_url_changed":
      return {
        ...state,
        mainScreenShotUrl: action.mainScreenShotUrl,
      };

    case "fetchedId_changed":
      return {
        ...state,
        fetchedId: action.fetchedId,
      };
    case "roledropdowndata_changed":
      return {
        ...state,
        formDataUserGrading: action.formDataUserGrading,
      };

    case "LoadingOverlay_changed":
      return {
        ...state,
        LoadingOverlay: action.LoadingOverlay,
      };
    case "Lison_Submit_Status_changed":
      return {
        ...state,
        SubmitLisonsStatus: action.SubmitLisonsStatus,
      };
    case "Set_BasicMetaData":
      return {
        ...state,
        basicMetaData: action.basicMetaData,
      };
    case "selected_area_Changed":
      return {
        ...state,
        SelectedArea: action.SelectedArea,
      };
    case "Lison_Input_Submit_Status_changed":
      return {
        ...state,
        MlLisonsInputsSubmitStatus: action.MlLisonsInputsSubmitStatus,
      };
    case "Op_Ref_Changed":
      return {
        ...state,
        OpRef: action.OpRef,
      };
    case "Op_Cornerstone_Ref_Changed":
      return {
        ...state,
        OpCornerstoneRef: action.OpCornerstoneRef,
      };

    case "Lison_Input_changed":
      return {
        ...state,
        MlLisonsInputData: action.MlLisonsInputData,
      };

    case "Lison_Option_changed":
      return {
        ...state,
        lisonOptions: action.lisonOptions,
      };
    case "Set_Lisons_Area_Data":
      return {
        ...state,
        lisonsAreasData: action.lisonsAreasData,
      };

    case "Lison_toggle_DATA":
      return {
        ...state,
        LisonData: action.LisonData,
      };

    case "Annotation_Rest_DATA":
      return {
        ...state,
        dicom_data_rest_annotation: action.rest_annotations_data,
      };
    case "Change_Lison_Active":
      return {
        ...state,
        LisonActive: action.lisonStatus,
      };
    case "NO_OF_STACKS":
      return {
        ...state,
        stacks: action.stacks,
      };
    case "DICOM_FETCH_META_SUCCESS":
      return {
        ...state,
        dicom_data: {
          ...state.dicom_data,
          [action.id]: action.dicom_data,
        },
      };

    case "REMOVE_STACK":
      let new_dicom_data = { ...state.dicom_data };
      delete new_dicom_data[action.id];
      return {
        ...state,
        dicom_data: new_dicom_data,
      };

    case "DICOM_CAN_SYNC_SCANS": {
      return {
        ...state,
        canSyncScans: action.canSyncScans,
      };
    }

    case "DICOM_SYNC_SCANS": {
      return {
        ...state,
        syncScans: action.syncScans,
      };
    }

    case "DICOM_CHANGE_FRAME":
      return {
        ...state,
        currentFrame: action.frame,
        changeFrameType: action.changeType,
        changeId: action.changeId,
      };

    case "SET_OPT_STACK":
      return {
        ...state,
        dicom_data: {
          ...state.dicom_data,
          [action.id]: {
            ...state.dicom_data[action.id],
            OPT: {
              ...state.dicom_data[action.id].OPT,
              stack: action.payload,
            },
            OP: {
              ...state.dicom_data[action.id].OP,
              vertical_line: null,
            },
          },
        },
      };

    case "SET_ANNOTATION_DATA":
      return {
        ...state,
        dicom_data: {
          ...state.dicom_data,
          [action.id]: {
            ...state.dicom_data[action.id],
            [action.key]: {
              ...state.dicom_data[action.id][action.key],
              annotations: action.payload,
            },
          },
        },
      };

    // On vertical line change (either from OP or other OPT)
    case "DICOM_CHANGE_VERTICAL_LINE":
      return {
        ...state,
        dicom_data: {
          ...state.dicom_data,
          [action.id]: {
            ...state.dicom_data[action.id],
            OPT: {
              ...state.dicom_data[action.id].OPT,
              vertical_line: action.OPT,
            },
            OP: {
              ...state.dicom_data[action.id].OP,
              vertical_line: action.OP,
            },
          },
        },
      };

    case "ANNOTATION_CHANGE_REQUEST":
      return {
        ...state,
        dicom_data: {
          ...state.dicom_data,
          [action.stack_id]: {
            ...state.dicom_data[action.stack_id],
            [action.key]: {
              ...state.dicom_data[action.stack_id][action.key],
              annotation_toggle: action.payload,
            },
          },
        },
      };

    case "TOGGLE_ANNOTATION_VISIBILITY":
      return {
        ...state,
        dicom_data: {
          ...state.dicom_data,
          [action.stack_id]: {
            ...state.dicom_data[action.stack_id],
            [action.key]: {
              ...state.dicom_data[action.stack_id][action.key],
              update: true,
              annotations: {
                ...state.dicom_data[action.stack_id][action.key].annotations,
                [action.payload.id]: {
                  ...state.dicom_data[action.stack_id][action.key].annotations[
                    action.payload.id
                  ],
                  data: state.dicom_data[action.stack_id][
                    action.key
                  ].annotations[action.payload.id].data.map(
                    (annot, annot_index) => {
                      if (annot_index === action.payload.index) {
                        return {
                          ...annot,
                          visible: action.payload.visible,
                        };
                      }
                    },
                  ),
                },
              },
            },
          },
        },
      };
    case "SET_THICKNESS_MAP":
      // Add thickness map to OP for stack id

      return {
        ...state,
        dicom_data: {
          ...state.dicom_data,
          [action.id]: {
            ...state.dicom_data[action.id],
            OP: {
              ...state.dicom_data[action.id].OP,
              thickness_map: action.payload,
            },
          },
        },
      };

    case "CHANGE_SELECTED_TOOL":
      return {
        ...state,
        selectedTool: action.payload,
      };
    case "SET_SEGMENTATION_ERASER_MODE":
      return {
        ...state,
        segmentationEraserMode: action.mode === "fluid" ? "fluid" : "ai",
      };
    case "SET_MANUAL_FLUID_TARGET_LABEL": {
      let next = null;
      if (
        action.label !== null &&
        action.label !== undefined &&
        action.label !== ""
      ) {
        const up = String(action.label).toUpperCase();
        if (["IRF", "SRF", "PED", "SHRM"].includes(up)) next = up;
      }
      return {
        ...state,
        manualFluidTargetLabel: next,
      };
    }
    case "SET_FLUID_BRUSH_DRAWING_MODE":
      return {
        ...state,
        fluidBrushDrawingMode: action.mode === "fill" ? "fill" : "stroke",
      };
    case "SET_FLUID_MANUAL_BRUSH_RADIUS": {
      const r =
        typeof action.radius === "number" && Number.isFinite(action.radius)
          ? action.radius
          : state.fluidManualBrushRadius;
      return {
        ...state,
        fluidManualBrushRadius: clampFluidManualBrushRadius(r),
      };
    }
    case "SET_SELECTED_KEY":
      return {
        ...state,
        selectedKey: action.key,
      };

    case "SET_GRID_WIDTH":
      return {
        ...state,
        width: action.width,
      };

    case "SET_THICKNESS_LUT":
      return {
        ...state,
        thicknessLUT: action.lut,
      };

    // Change brush settings
    case "SET_BRUSH_SEGMENTATION_INDEX":
      return {
        ...state,
        settings: {
          ...state.settings,
          brush: {
            ...state.settings.brush,
            activeSegment: action.index,
          },
          Segmentation: {
            ...state.settings.Segmentation,
          },
        },
      };
    case "SET_BRUSH_SHOW_MASKS":
      return {
        ...state,
        settings: {
          ...state.settings,
          brush: {
            ...state.settings.brush,
            showMasks: action.showMasks,
          },
          Segmentation: {
            ...state.settings.Segmentation,
          },
        },
      };
    case "SET_BRUSH_SHOW_ETDRS_MIRRORING":
      return {
        ...state,
        settings: {
          ...state.settings,
          brush: {
            ...state.settings.brush,
            showEtdrsMirroring: action.showEtdrsMirroring,
          },
          Segmentation: {
            ...state.settings.Segmentation,
          },
        },
      };
    case "SET_BRUSH_BORDER_RADIUS":
      return {
        ...state,
        settings: {
          ...state.settings,
          brush: {
            ...state.settings.brush,
            borderRadius: action.borderRadius,
          },
          Segmentation: {
            ...state.settings.Segmentation,
          },
        },
      };
    case "SET_FLUID_ERASER_DIAMETER":
      return {
        ...state,
        settings: {
          ...state.settings,
          brush: {
            ...state.settings.brush,
            fluidEraserDiameter:
              typeof action.diameter === "number" &&
              Number.isFinite(action.diameter)
                ? action.diameter
                : state.settings.brush.fluidEraserDiameter,
          },
          Segmentation: {
            ...state.settings.Segmentation,
          },
        },
      };
    case "SET_IMAGE_CONTRAST_VALUE":
      return {
        ...state,
        settings: {
          ...state.settings,
          imageContrast: {
            ...state.settings.imageContrast,
            value: clampImageContrast(action.value),
          },
        },
      };
    case "SET_SCREENSHOT_OPTION":
      return {
        ...state,
        settings: {
          ...state.settings,
          screenshot: {
            ...action.payload,
          },
          Segmentation: {
            ...state.settings.Segmentation,
          },
        },
      };
    case "UPDATE_LOCAL_SETTINGS":
      return {
        ...state,
        local_settings: {
          ...state.local_settings,
          FluidSegmentation: {
            ...state.local_settings.FluidSegmentation,
            ...action.FluidSegmentation,
          },
        },
      };

    case "UPDATE_USER_SETTINGS":
      return {
        ...state,
        settings: {
          ...action.settings,
          brush: {
            ...state.settings.brush,
            ...(action.settings.brush || {}),
          },
          Segmentation:
            action.settings.Segmentation || state.settings.Segmentation,
          // Preserve FluidSegmentationColors if not present in incoming payload
          FluidSegmentationColors:
            action.settings.FluidSegmentationColors ||
            state.settings.FluidSegmentationColors,
        },
      };

    case "UPDATE_IMAGE":
      return {
        ...state,
        update: state.update + 1,
      };

    case "UPDATE_DATA":
      return {
        ...state,
        update_data: action.data,
      };

    case "UPDATE_ALL_FRAMES_HANDLES":
      return {
        ...state,
        update_data: {
          type: "UPDATE_ALL_FRAMES_HANDLES",
          payload: action.payload,
        },
      };

    case "SET_PREV_START_REF":
      return {
        ...state,
        prevStartRef: action.payload,
      };

    default:
      return state;
  }
};
export default dicomReducer;
